import { useContext } from 'react';

import { Context } from '@r1-frontend/service-engineer-visit/context/Context';
import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const useContextSelector = <T>(selector: (state: TInitialState) => T) => {
    const { state } = useContext(Context);

    return selector(state);
};

export default useContextSelector;
